var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArkchatlogoLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 694,
    height: 593,
    viewBox: "0 0 694 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M779.229 309.312L777.21 310.927L496.189 592.756L90 592.755L373.444 309.312L104.536 40L509.917 40L777.21 307.293L779.229 309.312Z",
    fill: "#183243"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M689.229 269.312L687.21 270.927L406.189 552.756L-1.20809e-05 552.755L283.444 269.312L14.5356 3.17685e-07L419.917 9.17757e-06L687.21 267.293L689.229 269.312Z",
    fill: "#DB0011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkchatlogoLoading);
export default __webpack_public_path__ + "static/media/arkchatlogoLoading.78c48889e4b041b2a18f62deccf5292b.svg";
export { ForwardRef as ReactComponent };